import { connect } from 'react-redux';

import SubscriptionBillingModal from '../../components/SignUp/SubscriptionBillingModal/SubscriptionBillingModal';

const mapStateToProps = (state) => ({});

const SubscriptionBillingModalContainer = connect(
  mapStateToProps,
  null,
)(SubscriptionBillingModal);

export default SubscriptionBillingModalContainer;
